import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight, Loader2 } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";
import { api } from "@/lib/api";

export default function OkresyPage() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    document.title = "Zateplenie podľa okresov – ceny, firmy a obce | Zateplenia.eu";
    api.get("/seo/okresy").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  const regions = {};
  const cleanRegion = (r) => (r || "").replace(/\s*kraj$/i, "");
  (items || []).forEach((o) => {
    const reg = cleanRegion(o.region);
    (regions[reg] = regions[reg] || []).push(o);
  });
  const regionNames = Object.keys(regions).sort((a, b) => a.localeCompare(b, "sk"));

  return (
    <div className="min-h-screen bg-ink text-white">
      <Header />
      <main className="pt-32 pb-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10">
          <div className="font-mono2 text-xs uppercase tracking-widest text-gold mb-4">Lokálne zateplenie</div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-none mb-6">
            Zateplenie <span className="text-gold">podľa okresov</span>
          </h1>
          <p className="text-white/60 max-w-2xl mb-4">
            Vyberte si okres a pozrite si orientačné ceny zateplenia, zoznam obcí, kde pôsobíme,
            a overené realizačné firmy z regiónu. Cenu pre váš dom spočítate online do 60 sekúnd.
          </p>
          <p className="text-white/40 text-sm mb-12" data-testid="okresy-count">
            {items ? `${items.length} okresov · 1 000 obcí po celom Slovensku` : "Načítavam okresy…"}
          </p>

          {!items && <div className="flex items-center gap-2 text-white/50"><Loader2 className="w-5 h-5 animate-spin" /> Načítavam…</div>}

          {regionNames.map((region) => (
            <section key={region} className="mb-12" data-testid={`okresy-region-${region}`}>
              <h2 className="font-display text-2xl uppercase text-white/90 mb-4 flex items-center gap-2">
                <MapPin className="w-5 h-5 text-gold" /> {region || "Slovensko"} kraj
              </h2>
              <div className="flex flex-wrap gap-2">
                {regions[region].map((o) => (
                  <Link key={o.slug} to={`/okres/${o.slug}`} data-testid={`okres-link-${o.slug}`}
                    className="group border border-white/10 px-4 py-2.5 text-sm text-white/70 hover:border-gold hover:text-gold transition-colors">
                    {o.name}
                    <span className="text-white/30 group-hover:text-gold/60 ml-2 font-mono2 text-xs">{o.towns} obcí</span>
                  </Link>
                ))}
              </div>
            </section>
          ))}

          <div className="mt-16 border border-gold/30 bg-gold/5 p-8 flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <div className="font-display text-2xl uppercase mb-2">Poznáte svoj okres?</div>
              <p className="text-white/60 text-sm">Spočítajte si cenu zateplenia presne pre váš dom — materiál, práca, lešenie aj doprava.</p>
            </div>
            <Link to="/" data-testid="okresy-cta"
              className="group shrink-0 bg-gold text-ink px-8 py-4 font-bold uppercase tracking-wider text-sm flex items-center gap-2 hover:bg-gold-light transition-colors">
              Vypočítať cenu zdarma <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
